import React from "react";

const FiltersBar = () => {

  return (
    <div className="flex gap-4 mt-4">

      <select className="h-12 bg-gray-800 border border-gray-700 p-2 rounded">
        <option>Last Sprint</option>
        <option>Last 3 Sprints</option>
        <option>Last 30 Days</option>
      </select>

      <select className="h-12 bg-gray-800 border border-gray-700 p-2 rounded">
        <option>All Teams</option>
        <option>Team Alpha</option>
        <option>Team Beta</option>
      </select>

    </div>
  );
};

export default FiltersBar;